module.exports = __webpack_public_path__ + "img/9.c6b96691.png";